// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper-ec98d654"};